<app-header text='default'></app-header>

<div id="readspeaker_button_1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
  <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [attr.href]="getReadSpeakerURL('content')">
      <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
      <span class="rsbtn_right rsimg rsplay rspart"></span>
  </a>
</div>

<div class="container" *ngIf="!!course" id='content'>

  <div id="skill-container">
    <div class="float box shadow gradient icon-box" [ngClass]="{'red': course.skill === 'computer', 'green': course.skill === 'maths', 'yellow': course.skill === 'reading and writing'}">
      <fa-icon [icon]="icon"></fa-icon>
    </div>
    <div class="title float"><span i18n="">Skill</span>: {{ stringManagerService.normalizeText(course.skill) }}</div>
  </div>
  <div class="heading">
    <b i18n="">Course</b>
    <br/>
    {{ course.title }}
  </div>
  <div id="courseDescription" class="text" [innerHTML]="course.description"></div>

  <div class="text static" i18n="">Please use the contact details below to get in touch and start learning today!</div>

  <div class="course-info">
    <div class="row">
      <div class="col border center" *ngIf="!!course.location"><fa-icon [icon]="faMarker"></fa-icon><br/><b>{{ course.location[0].toUpperCase() + course.location.slice(1) }}</b></div>
      <div class="col border center" *ngIf="!!course.contact_person"><fa-icon [icon]="faUser"></fa-icon><br/><b>{{ course.contact_person }}</b></div>
      <div class="col border center" *ngIf="!!course.contact_telephone"><fa-icon [icon]="faPhone"></fa-icon><br/><b>{{ course.contact_telephone }}</b></div>
      <div class="col border center" *ngIf="!!course.contact_email"><fa-icon [icon]="faAt"></fa-icon><br/>{{ course.contact_email }}</div>
    </div>
    <div class="row">
      <div class="col border" *ngIf="course.enrolment_start || course.enrolment_finish">
        <fa-icon [icon]="faCalendar"></fa-icon>
        <span *ngIf="course.enrolment_start"><b><span i18n="">Enrolment Starts</span>: {{ course.enrolment_start | date:'fullDate' }}</b></span>
        <span *ngIf="course.enrolment_finish"><b><span i18n="">Enrolment Ends</span>: {{ course.enrolment_finish | date:'fullDate' }}</b></span>
      </div>
    </div>
  </div>
  <div class="text" i18n="">If you would like to find out more, click the <b>More info</b> button below.</div>
</div>
<div class="footer">
<div *ngIf="!!course && !!course.link; then thenBlock else elseBlock"></div>
</div>
<ng-template #thenBlock>
  <app-navigate-button
    backText="default"
    i18n-forwardText
    forwardText="More info"
    (backEvent)="goBack()"
    (forwardEvent)="loadLink(course.link)"
    ></app-navigate-button>
</ng-template>
<ng-template #elseBlock>
  <app-navigate-button
    text="default"
    (event)="goBack()"
    ></app-navigate-button>
</ng-template>
